import { useState, useEffect } from 'react';
import { useBlocker } from 'react-router';

import {
  ROUTE_EDIT_PAY_AND_POST,
  ROUTE_EDIT_SUCCESS,
} from 'src/app/shared/constants/routes';
import { useLocalisedRoutes } from 'src/app/v1/views/hooks/useLocalisedRoutes';

export const useNavigationBlockerEditFlow = () => {
  const [shouldNavigateToDashboard, setShouldNavigateToDashboard] =
    useState(false);

  const { redirectToDashboard } = useLocalisedRoutes();

  useEffect(() => {
    if (shouldNavigateToDashboard) {
      redirectToDashboard();
    }
  }, [shouldNavigateToDashboard, redirectToDashboard]);

  useBlocker(({ currentLocation, nextLocation }) => {
    // Redirect hirers to Dashboard if they try to navigate backwards from Success page
    if (
      currentLocation.pathname.includes(ROUTE_EDIT_SUCCESS) &&
      nextLocation.pathname.includes(ROUTE_EDIT_PAY_AND_POST)
    ) {
      setShouldNavigateToDashboard(true);
      return true;
    }

    return false;
  });
};
